import {ProductDeliveryItem} from "./ProductDeliveryItem";
import {getProductDeliveryData} from "../lib/getProductDeliveryData";
import {useSelectCityModalStore} from "@/features/select-city";
import {ProductData} from "@/entities/product";
import {useLocation} from "@/entities/location";
import styles from "./ProductDelivery.module.scss";

type Props = {
    productDataCurrent: ProductData;
};

export const ProductDelivery = ({productDataCurrent}: Props) => {
    const openModalSelectCity = useSelectCityModalStore(s => s.actions.openModal);
    const location = useLocation(s => s.location);

    const deliveryData = getProductDeliveryData(productDataCurrent);

    if (!deliveryData) {
        return null;
    }

    return (
        <div className={styles.container}>
            <button type={`button`} className={styles.title} onClick={openModalSelectCity}>
                Доставка: <span className={styles.titleLocation}>{location.city}</span>
            </button>
            {deliveryData.items.map((item) => (
                <ProductDeliveryItem key={item.key} item={item} productDataId={productDataCurrent.id} />
            ))}
        </div>
    );
}
